// https://km.sankuai.com/page/1315985984
import { isEmpty } from 'lodash'

// Raptor成功率code
enum MONITOR_VALUE {
  FAILED = 0, // 失败
  SUCCESS = 1, // 成功
}

// 安全距离
const SAFE_AREA = Mach.env.isIOS ? Mach.env.safeAreaInsets : {}

// 底部安全距离
// @ts-ignore
const SAFE_BOTTOM = !isEmpty(SAFE_AREA) ? SAFE_AREA.bottom : 0

// 状态栏高度
const STATUS_BAR_HEIGHT = Mach.env.statusBarHeight
// 导航栏高度
const NAVIGATION_BAR_HEIGHT = Mach.env.statusBarHeight

enum DEVICE_LEVEL {
  LOW = 'LOW',
  MIDDL = 'MIDDL',
  HIGH = 'HIGH',
  UN_KNOW = 'UN_KNOW',
}

export { MONITOR_VALUE, SAFE_BOTTOM, STATUS_BAR_HEIGHT, NAVIGATION_BAR_HEIGHT, DEVICE_LEVEL }
